// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// State
import { Store } from '@ngxs/store';
import { GlobalUtils, UIConfigComponent, UIConfigState } from '@cv-invision/core';
// Model
import { UIConfigStateModel, UIConfigStatus, UIConfigStyle } from '../model/ui-config.model';
import { UIConfigBroadcastModel } from '../model/ui-config-broadcast.model';
// Service
import { SystemApiService } from '../../service/system-api.service';
import { AppInformationService } from '../../service/app-info.service';
import { ConfigService } from '../../service/config.service';
// Other
import { Observable, Subject } from 'rxjs';
import { CLASS_VALUATION_PROVIDER } from '../../layout/header/service/users.service';

@Injectable({
	providedIn: 'root'
})
export class UIConfigService {

	public onUiConfigModelChange: Subject<UIConfigBroadcastModel> = new Subject<UIConfigBroadcastModel>();

	get UIConfigState(): UIConfigStateModel {
		return this.store.selectSnapshot(UIConfigState.getUIConfigState);
	}

	constructor(
		private http: HttpClient,
		private store: Store,
		private appInfo: AppInformationService,
		private systemApiService: SystemApiService,
		private configService: ConfigService
	) {
		this.onLoadUIConfig()
	}

	/**
	 * Get a Component Style
	 * @param uiConfigComponent
	 */
	public getComponentStyle(uiConfigComponent: UIConfigComponent): UIConfigStyle | any {
		const style: UIConfigStyle = null;
		const uiConfigStateModel: UIConfigStateModel = this.UIConfigState;
		if (uiConfigStateModel && uiConfigStateModel.application) {
			const appUIConfigModel: any = uiConfigStateModel.application[this.appInfo.appName];

			if (appUIConfigModel[uiConfigComponent]) {
				return appUIConfigModel[uiConfigComponent];
			}

			if (appUIConfigModel) {
				return appUIConfigModel.style[uiConfigComponent] || null;
			}
		}

		return style;
	}

	/**
	 * Wait for any change to the UI if this was loaded properly and propagated the change
	 * @private
	 */
	private onLoadUIConfig(): void {
		this.store
			.select(s => s.uiConfig)
			.subscribe((uiConfigStateModel: UIConfigStateModel) => {
				if (uiConfigStateModel && uiConfigStateModel.status === UIConfigStatus.READY) {
					// Only propagate changes for the current app you are
					const appUIConfigModel = uiConfigStateModel.application[this.appInfo.appName];
					if (appUIConfigModel) {
						// Get Supported Components
						const uiConfigComponents: string[] = Object.values(UIConfigComponent);

						if (appUIConfigModel.logo) {
							this.onUiConfigModelChange.next({
								component: UIConfigComponent.LOGO,
								styles: appUIConfigModel.logo
							});
						}
						uiConfigComponents.forEach((uiConfigComponent: string) => {
							const style = appUIConfigModel.style[uiConfigComponent];
							if (style) {
								this.onUiConfigModelChange.next({
									component: <UIConfigComponent>uiConfigComponent,
									styles: style
								});
							}
						});
					}

				}
			});
	}

	/**
	 * Load from the Server the Configuration Model
	 * @param organizationID
	 */
	public loadUIConfig(organizationID: string): Observable<any> {
		// return of(this.mockData);
		return this.http.get(
			`${this.configService.api.identitySystemService}${CLASS_VALUATION_PROVIDER}/organizations/${organizationID}/ui-config`
		);
	}

	public isUIAppConfiguredAndRunningInsideAFrame(): boolean {
		return GlobalUtils.isInsideIframe();
	}
}
